import { Suspense } from 'react';
import { Fade } from '@mui/material';

// project imports
import Loader from './Loader';
import ListSkeleton from './custom/ListSkeleton';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const QuestionLoader = (Component) => (props) =>
    (
        <Suspense
            fallback={
                <Fade in timeout={800}>
                    <div>
                        <ListSkeleton times={3} marginTop={10} />
                    </div>
                </Fade>
            }
        >
            <Component {...props} />
        </Suspense>
    );

export default QuestionLoader;
